import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-dental-surgical-history",
  templateUrl: "./dental-surgical-history.component.html",
  styleUrls: ["./dental-surgical-history.component.scss"],
})
export class DentalSurgicalHistoryComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
